import { render, staticRenderFns } from "./UserError.vue?vue&type=template&id=55370896&scoped=true&"
import script from "./UserError.vue?vue&type=script&lang=js&"
export * from "./UserError.vue?vue&type=script&lang=js&"
import style0 from "./UserError.vue?vue&type=style&index=0&id=55370896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55370896",
  null
  
)

export default component.exports